export const translations = {
  id: {
    // Navigation
    nav: {
      features: "Fitur",
      pricing: "Harga",
      faq: "FAQ",
      login: "Masuk",
      register: "Daftar Gratis",
      dashboard: "Dashboard",
      howItWorks: "Cara Kerja",
    },
    
    // Hero Section
    hero: {
      badge: "CRM Omnichannel + AI Customer Assistant",
      title: "AI Customer Assistant untuk",
      titleHighlight: "Toko Online Anda",
      subtitle: "Nerava menyatukan chat WhatsApp, Instagram, dan Facebook Messenger dalam satu inbox. AI menjawab pertanyaan produk, stok, dan ongkir berdasarkan data toko Anda sendiri — 24 jam, tanpa jawaban karangan.",
      cta: "Mulai Gratis",
      ctaTrial: "Coba Gratis 30 Hari",
      ctaDemo: "Lihat Demo",
      forWho: "Untuk toko online, UMKM, dan tim CS yang melayani pembeli lewat chat",
      viewFeatures: "Lihat Fitur",
      demo: "Lihat Demo",
      allFeatures: "Akses semua fitur",
      noCreditCard: "Tanpa kartu kredit",
      quickSetup: "Setup ±15 menit",
      channelsConnected: "channel terhubung",
      trustedBy: "WhatsApp, Instagram & Messenger lewat API resmi Meta",
      chatPlaceholder: "Ketik pesan...",
      chatResponse: "Halo! Saya asisten AI Nerava. Ada yang bisa saya bantu untuk bisnis Anda hari ini?",
      chatQuestion: "Bagaimana cara kerja Nerava?",
      chatQuestionDetail: "Bisakah Anda jelaskan lebih detail?",
    },
    
    // Features
    features: {
      title: "Satu Platform, Semua Kebutuhan Bisnis",
      subtitle: "Fitur lengkap untuk mengelola pelanggan dari prospek hingga closing dan repeat order.",
      omnichannel: "Omnichannel Inbox",
      omnichannelDesc: "WhatsApp, Instagram, Facebook dalam satu dashboard. Tidak perlu buka banyak aplikasi.",
      aiAgent: "AI Agent 24/7",
      aiAgentDesc: "Jawab pelanggan otomatis sesuai SOP bisnis Anda, bahkan saat Anda tidur.",
      orders: "Manajemen Pesanan",
      ordersDesc: "Kelola pesanan dari semua channel dengan filter canggih dan status tracking.",
      customers: "Database Pelanggan",
      customersDesc: "Lihat riwayat pembelian, total spending, dan analisis pelanggan repeat.",
      payment: "Katalog Produk",
      paymentDesc: "Upload produk dengan foto, harga, dan varian. AI akan mengenali produk Anda.",
      sheets: "Google Sheets Sync",
      sheetsDesc: "Data penjualan otomatis tersinkron ke spreadsheet. Laporan real-time.",
    },
    
    // How It Works
    howItWorks: {
      title: "Cara Kerja Nerava",
      subtitle: "Dari setup hingga closing dalam 4 langkah sederhana",
      eyebrow: "Alur Kerja",
      footnote: "Tanpa coding dan tanpa tim IT. Keempat langkah ini dikerjakan sendiri dari dashboard.",
      step1Title: "Hubungkan Channel",
      step1Desc: "Integrasikan WhatsApp, Instagram, Facebook ke Nerava dalam hitungan menit.",
      step1Meta: "± 3 menit",
      step2Title: "Setup AI Agent",
      step2Desc: "Latih AI dengan FAQ, product catalog, dan SOP bisnis Anda.",
      step2Meta: "± 10 menit",
      step3Title: "Kelola Pelanggan",
      step3Desc: "Pantau semua percakapan, leads, dan pipeline penjualan dari satu dashboard.",
      step3Meta: "Jalan 24/7",
      step4Title: "Closing & Payment",
      step4Desc: "Terima pesanan, kirim invoice, dan terima pembayaran langsung dari chat.",
      step4Meta: "Langsung dari chat",
    },

    // Label kecil di atas judul section
    eyebrows: {
      features: "Fitur Utama",
      demo: "Demo Produk",
      trust: "Keamanan & Dukungan",
      faq: "Pertanyaan Umum",
      cta: "Mulai Sekarang",
    },
    featuresNote: "Semua fitur di bawah aktif sejak hari pertama, termasuk saat masa uji coba.",
    faqNote: "Masih ada yang mau ditanya? Kirim email ke support@nerava.id, dibalas di hari kerja.",
    
    // Testimonials
    demoSection: {
      title: "Lihat Nerava Menjawab Pelanggan",
      subtitle: "Tiga situasi yang paling sering terjadi di chat toko online, dijawab memakai fitur yang sudah berjalan.",
    },
    trustSection: {
      title: "Keamanan, Privasi, dan Dukungan",
      subtitle: "Akun, token channel, dan data pelanggan Anda dijaga di setiap lapisan — dari cara Anda login sampai cara Nerava terhubung ke WhatsApp dan Instagram.",
    },
    
    // FAQ
    faq: {
      title: "Pertanyaan yang Sering Diajukan",
      subtitle: "Jawaban untuk pertanyaan umum tentang Nerava",
      q1: "Apa itu Nerava?",
      a1: "Nerava adalah platform all-in-one untuk online seller yang menggabungkan omnichannel chat (WhatsApp, Instagram, Facebook Messenger, dan live chat website), AI agent otomatis, CRM, broadcast, dan payment integration dalam satu dashboard. Semua yang Anda butuhkan untuk mengelola pembeli dari prospek hingga closing.",
      q2: "Berapa lama waktu setup?",
      a2: "Sekitar 15 menit: ±3 menit menghubungkan channel dan ±10 menit mengisi katalog produk serta FAQ. Setelah itu AI langsung bisa menjawab pelanggan.",
      q3: "Apakah ada biaya tersembunyi?",
      a3: "Dari sisi Nerava tidak ada biaya tersembunyi — semua fitur paket sudah termasuk dalam harga langganan. Satu hal yang perlu Anda tahu: kalau Anda memakai nomor WhatsApp Business sendiri, Meta menagih biaya pesan layanan langsung ke akun WhatsApp Anda setelah melewati 1.000 pesan gratis per bulan. Itu tagihan dari Meta, bukan dari kami. Chat lewat Instagram, Messenger, dan website tidak kena biaya pesan.",
      q4: "Bisakah saya upgrade atau downgrade paket?",
      a4: "Ya, Anda bisa upgrade atau downgrade paket kapan saja. Perubahan akan berlaku di periode tagihan berikutnya.",
      q5: "Channel apa saja yang didukung?",
      a5: "Nerava mendukung WhatsApp Business API, Instagram DM, Facebook Messenger, dan website live chat. Semua dalam satu inbox terintegrasi.",
      q6: "Apakah data saya aman?",
      a6: "Password disimpan sebagai hash bcrypt, token channel WhatsApp/Instagram dienkripsi di database, dan seluruh trafik lewat HTTPS. Data tiap akun terpisah — hanya Anda dan tim yang Anda undang yang bisa melihatnya. Permintaan ekspor atau hapus data dilayani lewat email support.",
    },
    
    // Showcase Sections
    showcase: {
      inbox: {
        title: "Semua Chat, Satu Dashboard",
        subtitle: "Tidak perlu lagi buka WhatsApp, Instagram, dan Facebook secara terpisah. Semua pesan masuk ke satu inbox yang terintegrasi.",
        feature1: "WhatsApp Business API terintegrasi",
        feature2: "Instagram DM auto-reply",
        feature3: "Facebook Messenger support",
        feature4: "Filter berdasarkan status & channel",
        feature5: "Riwayat chat tersimpan otomatis",
        all: "Semua",
        newMessage: "Pesan baru...",
      },
      orders: {
        title: "Kelola Pesanan dengan Mudah",
        subtitle: "Semua pesanan dari berbagai channel dalam satu tampilan. Filter, cari, dan tracking status dengan mudah.",
        feature1: "Filter by channel, produk, tanggal",
        feature2: "Status tracking real-time",
        feature3: "Notifikasi pesanan baru",
        feature4: "Export data ke Excel",
      },
      ai: {
        title: "AI Agent yang Memahami Bisnis Anda",
        subtitle: "Latih AI dengan product catalog, FAQ, dan SOP bisnis Anda. AI akan menjawab pelanggan 24/7 sesuai brand voice Anda.",
        feature1: "Training dengan data bisnis Anda",
        feature2: "Memahami konteks percakapan",
        feature3: "Handover ke human saat diperlukan",
        feature4: "Multi-bahasa (ID & EN)",
      },
      customers: {
        title: "Kenali Pelanggan Anda Lebih Baik",
        subtitle: "Database pelanggan lengkap dengan riwayat pembelian, total spending, dan identifikasi pelanggan repeat.",
        feature1: "Riwayat pembelian lengkap",
        feature2: "Analisis pelanggan repeat",
        feature3: "Lifetime value tracking",
        feature4: "Pencarian & filter cepat",
      },
      catalog: {
        title: "Katalog Produk Terintegrasi AI",
        subtitle: "Upload produk Anda dan AI akan mengenalinya. Pelanggan bisa tanya harga, stok, dan detail produk via chat.",
        feature1: "Upload foto & detail produk",
        feature2: "AI mengenali produk otomatis",
        feature3: "Kelola stok & varian",
        feature4: "Integrasi dengan chat AI",
      },
    },
    
    // Pricing
    pricing: {
      title: "Harga Terjangkau untuk UMKM",
      subtitle: "Pilih paket yang sesuai dengan kebutuhan bisnis Anda",
      free: "Gratis",
      pro: "Pro",
      enterprise: "Enterprise",
      perMonth: "/bulan",
      startFree: "Mulai Gratis",
      choosePro: "Pilih Pro",
      contactSales: "Hubungi Sales",
      freePlan: {
        description: "Cocok untuk memulai",
        aiAgent: "1 AI Agent",
        chats: "100 chat/bulan",
        analytics: "Analitik dasar",
        support: "Dukungan email",
      },
      proPlan: {
        description: "Untuk bisnis berkembang",
        aiAgents: "5 AI Agent",
        chats: "5.000 chat/bulan",
        analytics: "CRM & Pipeline lengkap",
        support: "Dukungan prioritas",
        customization: "Broadcast unlimited",
      },
      enterprisePlan: {
        description: "Untuk perusahaan besar",
        unlimited: "Unlimited AI Agent",
        unlimitedChats: "Unlimited chat",
        advancedAnalytics: "Analitik advanced",
        dedicatedSupport: "Dukungan dedicated",
        customIntegration: "Integrasi custom",
        sla: "SLA guarantee",
      },
      cta: {
        title: "Siap Tingkatkan Efisiensi Bisnis?",
        subtitle: "Mulai gratis 30 hari, hubungkan channel Anda, dan biarkan AI menjawab pertanyaan pelanggan sesuai data toko Anda.",
        button: "Coba Gratis 30 Hari",
        note: "Tanpa kartu kredit • Akses semua fitur • Cancel kapan saja",
      },
    },
    
    // Footer
    footer: {
      description: "Platform all-in-one untuk online seller Indonesia. Omnichannel chat, AI agent, CRM, dan payment dalam satu dashboard.",
      product: "Produk",
      channels: "Channels",
      pricing: "Harga",
      company: "Perusahaan",
      about: "Tentang Kami",
      careers: "Karir",
      blog: "Blog",
      contact: "Kontak",
      legal: "Legal",
      privacy: "Kebijakan Privasi",
      terms: "Syarat & Ketentuan",
      copyright: "Hak cipta",
      allRightsReserved: "Seluruh hak dilindungi",
    },
    
    // Integration
    integration: {
      title: "Hubungkan Semua Channel Anda",
      subtitle: "Nerava terintegrasi dengan platform komunikasi yang bisnis Anda gunakan",
      wordpress: "Pasang dengan plugin atau kode embed",
      shopify: "Integrasi melalui theme editor",
      wix: "Tambahkan via HTML embed",
      custom: "Copy-paste kode JavaScript",
      laravel: "Integrasi via Blade template",
      react: "Import sebagai script tag",
    },
    
    // Documentation
    documentation: {
      title: "Dokumentasi",
      subtitle: "Panduan lengkap untuk memulai dengan Nerava",
      quickStart: "Quick Start",
      quickStartDesc: "Mulai dalam 5 menit dengan panduan instalasi",
      apiDocs: "API Documentation",
      apiDocsDesc: "Referensi lengkap API untuk integrasi advanced",
      customization: "Customization Guide",
      customizationDesc: "Pelajari cara mengkustomisasi AI Agent Anda",
    },
    
    
    // Contact
    contact: {
      title: "Hubungi Kami",
      subtitle: "Punya pertanyaan? Tim kami siap membantu",
      email: "Email",
      whatsapp: "WhatsApp",
      response: "Kami akan merespons dalam 24 jam",
    },
    
    // Modal
    modal: {
      title: "Kelola Pelanggan Lebih Efisien!",
      subtitle: "Satukan chat",
      thousands: "WhatsApp, Instagram & Messenger",
      using: "dalam satu inbox ber-AI",
      benefit1: "Gratis 30 hari, tanpa kartu kredit",
      benefit2: "Setup ±15 menit",
      benefit3: "Dukungan Bahasa Indonesia",
      registerNow: "Daftar Sekarang - Gratis!",
      haveAccount: "Sudah Punya Akun? Masuk",
      close: "Tutup",
    },
    
    // Dashboard
    dashboard: {
      title: "Dashboard",
      welcome: "Selamat datang kembali",
      yourPlan: "Paket Anda",
      upgrade: "Upgrade",
      usage: "Penggunaan",
      aiAgents: "AI Agent",
      chats: "Chat bulan ini",
      totalChats: "Total Chat",
      activeBots: "Agent Aktif",
      avgResponse: "Rata-rata Respons",
      createBot: "Buat Agent",
      myBots: "Agents",
      noBots: "Belum ada AI Agent",
      createFirst: "Buat AI Agent pertama Anda",
      viewDetails: "Lihat Detail",
      analytics: "Analitik",
      // Create Modal
      createModalTitle: "Buat AI Agent Baru",
      createModalSubtitle: "Setup Cepat!",
      createModalDesc: "Buat AI agent Anda dalam 2 langkah mudah. Setelah dibuat, Anda bisa kustomisasi lebih lanjut.",
      botName: "Nama AI Agent",
      botNamePlaceholder: "Contoh: Customer Support Agent",
      botNameDesc: "Berikan nama yang mudah diingat",
      description: "Deskripsi (Opsional)",
      descPlaceholder: "Contoh: AI Agent untuk menjawab pertanyaan pelanggan tentang produk dan layanan",
      descDesc: "Jelaskan fungsi AI Agent Anda",
      tips: "Tips",
      tipsText: "Setelah AI Agent dibuat, Anda bisa mengatur prompt, FAQ, warna, dan menghubungkan ke channel seperti WhatsApp.",
      cancel: "Batal",
      create: "Buat AI Agent",
      creating: "Membuat...",
      // Dashboard extended
      overview: "Ringkasan",
      todayStats: "Statistik Hari Ini",
      totalRevenue: "Total Pendapatan",
      totalOrders: "Total Pesanan",
      newCustomers: "Pelanggan Baru",
      pendingOrders: "Pesanan Pending",
      recentOrders: "Pesanan Terbaru",
      recentConversations: "Percakapan Terbaru",
      viewAll: "Lihat Semua",
      noOrders: "Belum ada pesanan",
      noConversations: "Belum ada percakapan",
      quickActions: "Aksi Cepat",
      newOrder: "Pesanan Baru",
      addProduct: "Tambah Produk",
      sendBroadcast: "Kirim Broadcast",
      // Order Status
      orderStatus: {
        pending: "Menunggu",
        paid: "Dibayar",
        processing: "Diproses",
        shipped: "Dikirim",
        delivered: "Diterima",
        cancelled: "Dibatalkan",
      },
      // Trial
      trialExpires: "Trial berakhir dalam",
      days: "hari",
      hours: "jam",
      minutes: "menit",
      seconds: "detik",
      trialExpired: "Trial Berakhir",
      upgradeToPro: "Upgrade ke Pro",
      // Insights
      conversionFunnel: "Funnel Konversi",
      channelPerformance: "Performa Channel",
      customerInsights: "Insight Pelanggan",
      responseTime: "Waktu Respons",
      avgResponseTime: "Rata-rata Waktu Respons",
    },
    
    // Profile
    profile: {
      title: "Pengaturan Profil",
      info: "Informasi Profil",
      name: "Nama Lengkap",
      namePlaceholder: "Nama Anda",
      email: "Email",
      emailNote: "Email tidak dapat diubah",
      updateInfo: "Perbarui Informasi",
      changePassword: "Ubah Password",
      currentPassword: "Password Saat Ini",
      currentPasswordPlaceholder: "Password saat ini",
      newPassword: "Password Baru",
      newPasswordPlaceholder: "Password baru (min. 6 karakter)",
      confirmPassword: "Konfirmasi Password Baru",
      confirmPasswordPlaceholder: "Ulangi password baru",
      updatePassword: "Ubah Password",
      saveProfile: "Simpan Profil",
      saving: "Menyimpan...",
      success: "Profil berhasil diperbarui",
      passwordSuccess: "Password berhasil diperbarui",
      nameEmpty: "Nama tidak boleh kosong",
      passwordFieldsRequired: "Semua field password harus diisi",
      passwordMinLength: "Password baru minimal 6 karakter",
      passwordMismatch: "Password baru tidak cocok",
      updateFailed: "Gagal memperbarui profil",
      passwordUpdateFailed: "Gagal memperbarui password",
      // Notifications
      notificationsSaved: "Pengaturan notifikasi disimpan",
      notificationsSaveFailed: "Gagal menyimpan pengaturan",
      enterTelegramId: "Masukkan Chat ID Telegram",
      telegramVerified: "Telegram berhasil diverifikasi! Cek pesan di Telegram Anda.",
      telegramVerifyFailed: "Gagal verifikasi Telegram",
      testNotifFailed: "Gagal mengirim test notifikasi",
      // Additional keys from Profile Page
      personalInfo: "Informasi Pribadi",
      fullName: "Nama Lengkap",
      phone: "Nomor Telepon",
      updateProfile: "Update Profil",
      profileUpdated: "Profil berhasil diupdate",
      passwordChanged: "Password berhasil diubah",
      incorrectPassword: "Password saat ini salah",
      // Business Profile
      businessProfile: "Profil Bisnis",
      storeName: "Nama Toko",
      businessCategory: "Kategori Bisnis",
      businessDescription: "Deskripsi Bisnis",
      storeAddress: "Alamat Toko",
      city: "Kota",
      saveBusinessProfile: "Simpan Profil Bisnis",
      savingBusiness: "Menyimpan...",
      selectCategory: "Pilih kategori",
      storeNamePlaceholder: "Contoh: Toko Bunga Mawar",
      descriptionPlaceholder: "Ceritakan tentang bisnis Anda...",
      addressPlaceholder: "Jl. Contoh No. 123",
      cityPlaceholder: "Jakarta",
    },
    
    // Payment
    payment: {
      title: "Pembayaran",
      subtitle: "Pilih metode pembayaran untuk upgrade ke paket",
      method: "Metode Pembayaran",
      bankTransfer: "Transfer Bank (Virtual Account)",
      bankTransferDesc: "BCA, BNI, Mandiri, BRI, Permata, CIMB",
      eWallet: "E-Wallet / Dompet Digital",
      eWalletDesc: "OVO, DANA, GoPay, ShopeePay, LinkAja",
      qris: "QRIS",
      qrisDesc: "Scan QR dari semua e-wallet & mobile banking",
      creditCard: "Kartu Kredit / Debit",
      creditCardDesc: "Visa, Mastercard, JCB",
      selectBank: "Pilih Bank",
      selectWallet: "Pilih E-Wallet",
      orderSummary: "Ringkasan Pesanan",
      package: "Paket",
      period: "Periode",
      month: "bulan",
      total: "Total",
      payNow: "Bayar Sekarang",
      processing: "Memproses...",
      securePayment: "Pembayaran aman & terenkripsi",
      selectMethod: "Pilih metode pembayaran",
      selectBankError: "Pilih bank untuk transfer",
      selectWalletError: "Pilih e-wallet",
      processingPayment: "Memproses pembayaran...",
      paymentSuccess: "Pembayaran berhasil! Terima kasih telah berlangganan.",
    },
    
    // Plan Limit Messages
    limits: {
      aiAgentLimit: "Batas AI Agent tercapai",
      aiAgentLimitDesc: "Plan {plan} hanya dapat membuat {max} AI Agent. Upgrade ke plan Pro untuk membuat lebih banyak.",
      chatLimit: "Batas chat bulanan tercapai",
      chatLimitDesc: "Anda telah mencapai batas {max} chat per bulan. Upgrade ke plan Pro untuk chat lebih banyak.",
      upgradeNow: "Upgrade Sekarang",
    },
    
    // AI Agent Detail
    aiAgentDetail: {
      editAiAgent: "Edit AI Agent",
      viewAnalytics: "Lihat Analitik",
      save: "Simpan",
      saving: "Menyimpan...",
      tabGeneral: "Umum",
      tabPrompt: "Prompt",
      tabFaq: "FAQ",
      tabEmbed: "Embed",
      basicInfo: "Informasi Dasar",
      aiAgentName: "Nama AI Agent",
      description: "Deskripsi",
      widgetAppearance: "Tampilan Widget",
      primaryColor: "Warna Utama",
      welcomeMessage: "Pesan Sambutan",
      language: "Bahasa",
      languageId: "Bahasa Indonesia",
      languageEn: "English",
      languageBoth: "Keduanya (Auto-detect)",
      systemPrompt: "System Prompt",
      systemPromptDesc: "Instruksi dasar untuk AI tentang bagaimana agent harus berperilaku. Jangan ubah prompt dibawah agar menghasilkan performa AI yang maksimal",
      promptSizeLabel: "Panjang prompt",
      promptSizeChars: "karakter",
      promptSizeTokens: "token/balasan",
      promptSizeHint: "Prompt ini dikirim ulang ke AI setiap kali customer mengirim pesan.",
      promptSizeIdeal: "Ideal — respons cepat dan biaya AI paling hemat.",
      promptSizeWarn: "Agak panjang. Ringkas ke bawah 1.500 karakter agar AI lebih cepat dan hemat.",
      promptSizeHigh: "Terlalu panjang. Pindahkan detail produk ke Katalog Produk dan pertanyaan umum ke tab FAQ — jangan ditumpuk di prompt.",
      systemPromptPlaceholder: "Contoh: Anda adalah asisten customer service untuk Toko XYZ. Jawab pertanyaan dengan ramah dan profesional. Jika tidak tahu, arahkan ke kontak CS.",
      faqTitle: "FAQ",
      faqDesc: "Tambahkan pertanyaan umum untuk respons yang lebih akurat",
      addFaq: "Tambah FAQ",
      noFaq: "Belum ada FAQ. Klik tombol di atas untuk menambahkan.",
      faqNumber: "FAQ #",
      question: "Pertanyaan",
      questionPlaceholder: "Contoh: Berapa harga produk A?",
      answer: "Jawaban",
      answerPlaceholder: "Jawaban untuk pertanyaan di atas",
      embedCode: "Kode Embed",
      embedDesc: "Copy kode di bawah dan paste sebelum tag </body> di website Anda.",
      generateEmbed: "Generate Kode Embed",
      generating: "Membuat...",
      regenerate: "Generate Ulang",
      previewChat: "Preview Chat",
      previewDesc: "Uji AI Agent Anda di sini",
      typePlaceholder: "Ketik pesan...",
      loadFailed: "Gagal memuat data AI Agent",
      saveSuccess: "AI Agent berhasil disimpan!",
      saveFailed: "Gagal menyimpan AI Agent",
      embedSuccess: "Kode embed berhasil dibuat!",
      embedFailed: "Gagal membuat kode embed",
      codeCopied: "Kode disalin!",
      errorMessage: "Maaf, terjadi kesalahan.",
    },

    // Analytics
    analytics: {
      title: "Analitik",
      overallPerformance: "Performa Keseluruhan",
      aiAgentAnalytics: "Analitik per AI Agent",
      viewFullAnalytics: "Lihat Analitik Lengkap",
      conversations: "Percakapan",
      avgResponseTime: "Waktu Respons Rata-rata",
      satisfactionRate: "Tingkat Kepuasan",
      activeUsers: "Pengguna Aktif",
      topQuestions: "Pertanyaan Teratas",
      sentimentAnalysis: "Analisis Sentimen",
      positive: "Positif",
      neutral: "Netral",
      negative: "Negatif",
      recentChats: "Chat Terbaru",
      noData: "Belum ada data",
      loading: "Memuat...",
    },
    
    // Auth & Errors
    auth: {
      loginSuccess: "Login berhasil!",
      continueWithGoogle: "Lanjutkan dengan Google",
      orDivider: "atau",
      googleLoginFailed: "Login Google gagal, silakan coba lagi",
      connectingGoogle: "Menghubungkan akun Google...",
      loginFailed: "Login gagal",
      registerSuccess: "Registrasi berhasil!",
      registerFailed: "Registrasi gagal",
      welcomeBack: "Selamat Datang Kembali!",
      welcomeBackDesc: "Masuk untuk mengelola bisnis Anda dan pantau semua percakapan pelanggan.",
      loginToAccount: "Masuk ke Akun",
      loginSubtitle: "Silakan masukkan email dan password Anda",
      startJourney: "Mulai Perjalanan Anda",
      joinBusiness: "Satukan chat WhatsApp, Instagram, dan Messenger dalam satu inbox ber-AI",
      createAccount: "Buat akun Anda dan mulai gratis",
      benefit1: "Gratis 30 hari, tanpa kartu kredit",
      benefit2: "Setup ±15 menit",
      benefit3: "Dukungan Bahasa Indonesia",
      testimonialText: "AI menjawab pertanyaan produk, stok, dan ongkir dari data toko Anda sendiri. Chat WhatsApp, Instagram, dan Messenger masuk ke satu inbox, lengkap dengan pesanan dan pembayarannya.",
      testimonialName: "Yang Anda dapat sejak hari pertama",
      testimonialRole: "Semua fitur aktif selama masa uji coba",
      loginTitle: "Masuk",
      registerTitle: "Daftar",
      dontHaveAccount: "Belum punya akun?",
      alreadyHaveAccount: "Sudah punya akun?",
      signUpFree: "Daftar Gratis",
      email: "Email",
      password: "Password",
      name: "Nama",
      enterPassword: "Masukkan password",
      enterEmail: "nama@email.com",
      enterName: "Masukkan nama lengkap",
      login: "Masuk",
      register: "Daftar",
      creating: "Membuat akun...",
      passwordShort: "Password minimal 6 karakter",
    },
    
    // Error Messages
    errors: {
      aiAgentLimitReached: "Batas AI Agent tercapai. Plan FREE hanya dapat membuat 1 AI Agent. Upgrade ke plan Pro untuk membuat lebih banyak.",
      chatLimitReached: "Batas chat bulanan tercapai. Upgrade ke plan Pro untuk chat lebih banyak.",
    },

    // Inbox Page
    inbox: {
      title: "Inbox",
      subtitle: "Kelola semua percakapan pelanggan di satu tempat",
      allChannels: "Semua Channel",
      whatsapp: "WhatsApp",
      messenger: "Messenger",
      instagram: "Instagram", 
      website: "Website",
      search: "Cari percakapan...",
      noConversations: "Belum ada percakapan",
      noConversationsDesc: "Percakapan akan muncul di sini ketika pelanggan mulai chat",
      unread: "belum dibaca",
      bot: "Bot",
      human: "Manual",
      resolved: "Selesai",
      active: "Aktif",
      filterAll: "Semua",
      filterUnread: "Belum Dibaca",
      filterBot: "Bot Aktif",
      filterHuman: "Manual",
      needsAttention: "Perlu Perhatian",
      notificationsActive: "Notifikasi aktif",
      enableNotifications: "Aktifkan notifikasi",
      viewAnalytics: "Lihat Analytics",
      waitingMessages: "Menunggu pesan masuk",
      channelConnectedDesc: "Channel sudah terhubung. Pesan dari pelanggan akan muncul di sini secara otomatis.",
      connectChannel: "Hubungkan Channel",
      // Bulk Actions
      selected: "dipilih",
      selectAll: "Pilih semua",
      deselectAll: "Batalkan pilihan",
      markRead: "Sudah Dibaca",
      markUnread: "Belum Dibaca",
      archive: "Arsip",
      unarchive: "Kembalikan",
      delete: "Hapus",
      bulkMarkReadSuccess: "Percakapan berhasil ditandai sudah dibaca",
      bulkMarkUnreadSuccess: "Percakapan berhasil ditandai belum dibaca",
      bulkArchiveSuccess: "Percakapan berhasil diarsipkan",
      bulkUnarchiveSuccess: "Percakapan berhasil dikembalikan dari arsip",
      bulkDeleteSuccess: "Percakapan berhasil dihapus",
      bulkActionError: "Gagal melakukan aksi massal",
    },

    // Conversation Detail
    conversation: {
      backToInbox: "Kembali ke Inbox",
      customer: "Pelanggan",
      channel: "Channel",
      status: "Status",
      handledBy: "Ditangani oleh",
      takeOver: "Ambil Alih (Manual)",
      handToBot: "Kembalikan ke Bot",
      markResolved: "Tandai Selesai",
      reopen: "Buka Kembali",
      typeMessage: "Ketik balasan Anda...",
      send: "Kirim",
      sending: "Mengirim...",
      you: "Anda",
      botActive: "Bot aktif - klik menu untuk Ambil Alih",
      manualMode: "Mode manual - Bot dijeda",
      noMessages: "Belum ada pesan dalam percakapan ini",
      notFound: "Conversation tidak ditemukan",
      viewCustomerProfile: "Lihat Profil Customer",
    },

    // Customers Page
    customers: {
      title: "Pelanggan",
      subtitle: "Kelola database pelanggan Anda",
      search: "Cari pelanggan...",
      addCustomer: "Tambah Pelanggan",
      exportExcel: "Export Excel",
      name: "Nama",
      phone: "Telepon",
      email: "Email",
      channel: "Channel",
      totalOrders: "Total Pesanan",
      totalSpent: "Total Belanja",
      lastContact: "Kontak Terakhir",
      actions: "Aksi",
      noCustomers: "Belum ada pelanggan",
      noCustomersDesc: "Pelanggan akan muncul di sini ketika mereka mulai chat",
      viewDetails: "Lihat Detail",
      edit: "Edit",
      delete: "Hapus",
      confirmDelete: "Apakah Anda yakin ingin menghapus pelanggan ini?",
      totalCustomers: "Total Pelanggan",
      new: "Baru",
      thisMonth: "Bulan ini",
      repeat: "Repeat",
      avgSpent: "Rata-rata Belanja",
      perCustomer: "Per pelanggan",
      orderHistory: "Riwayat Pesanan",
      saveNotes: "Simpan Catatan",
      addNotesPlaceholder: "Tambahkan catatan tentang pelanggan ini...",
      // Extended customers keys
      searchCustomers: "Cari nama, no HP, alamat...",
      activeCustomers: "Pelanggan Aktif",
      newThisMonth: "Baru Bulan Ini",
      lastOrder: "Pesanan Terakhir",
      joined: "Bergabung",
      // Customer Detail
      customerDetail: "Detail Pelanggan",
      conversationHistory: "Riwayat Percakapan",
      customerNotes: "Catatan Pelanggan",
      addNote: "Tambah Catatan",
      notesSaved: "Catatan tersimpan",
      notesSaveFailed: "Gagal menyimpan catatan",
      // Add/Edit Customer
      addNewCustomer: "Tambah Pelanggan Baru",
      editCustomer: "Edit Pelanggan",
      customerName: "Nama Pelanggan",
      customerPhone: "Nomor Telepon",
      customerEmail: "Alamat Email",
      customerAddress: "Alamat",
      saveCustomer: "Simpan Pelanggan",
      customerSaved: "Pelanggan berhasil disimpan",
      customerCreated: "Pelanggan berhasil ditambahkan",
      customerDeleted: "Pelanggan berhasil dihapus",
      confirmDeleteCustomer: "Yakin ingin menghapus pelanggan ini?",
      loadError: "Gagal memuat detail pelanggan",
    },

    // Orders Page
    orders: {
      title: "Pesanan",
      subtitle: "Kelola semua pesanan Anda",
      search: "Cari pesanan...",
      addOrder: "Tambah Pesanan",
      exportExcel: "Export Excel",
      orderId: "ID Pesanan",
      customer: "Pelanggan",
      products: "Produk",
      total: "Total",
      status: "Status",
      paymentStatus: "Pembayaran",
      date: "Tanggal",
      actions: "Aksi",
      noOrders: "Belum ada pesanan",
      noOrdersDesc: "Pesanan akan muncul di sini ketika pelanggan melakukan pembelian",
      viewDetails: "Lihat Detail",
      updateStatus: "Update Status",
      pending: "Menunggu",
      processing: "Diproses",
      shipped: "Dikirim",
      delivered: "Terkirim",
      cancelled: "Dibatalkan",
      paid: "Lunas",
      unpaid: "Belum Bayar",
      refunded: "Refund",
      // Extended orders keys
      newOrder: "Pesanan Baru",
      searchOrders: "Cari order ID, nama, produk...",
      filterByStatus: "Filter status",
      allStatus: "Semua Status",
      orderNumber: "No. Pesanan",
      viewOrder: "Lihat Pesanan",
      editOrder: "Edit Pesanan",
      deleteOrder: "Hapus Pesanan",
      confirmDelete: "Yakin ingin menghapus pesanan ini?",
      orderDeleted: "Pesanan berhasil dihapus",
      totalOrders: "Total Pesanan",
      receivables: "Piutang",
      revenue: "Revenue",
      loadError: "Gagal memuat pesanan",
      statusUpdated: "Status berhasil diupdate",
      statusUpdateFailed: "Gagal update status",
      trackingSaved: "Info pengiriman berhasil disimpan",
      trackingSaveFailed: "Gagal menyimpan info pengiriman",
      // Order Detail
      orderDetail: "Detail Pesanan",
      orderInfo: "Informasi Pesanan",
      customerInfo: "Informasi Pelanggan",
      items: "Item",
      subtotal: "Subtotal",
      shipping: "Ongkir",
      discount: "Diskon",
      grandTotal: "Total",
      paymentMethod: "Metode Pembayaran",
      shippingAddress: "Alamat Pengiriman",
      notes: "Catatan",
      timeline: "Timeline",
      // Create/Edit Order
      createOrder: "Buat Pesanan",
      editOrderTitle: "Edit Pesanan",
      selectCustomer: "Pilih Pelanggan",
      addItem: "Tambah Item",
      selectProduct: "Pilih Produk",
      quantity: "Jumlah",
      price: "Harga",
      removeItem: "Hapus Item",
      saveOrder: "Simpan Pesanan",
      orderSaved: "Pesanan berhasil disimpan",
      orderCreated: "Pesanan berhasil dibuat",
    },

    // Settings Page
    settings: {
      title: "Pengaturan",
      general: "Umum",
      notifications: "Notifikasi",
      billing: "Tagihan",
      team: "Tim",
      businessInfo: "Informasi Bisnis",
      businessName: "Nama Bisnis",
      businessNamePlaceholder: "Masukkan nama bisnis Anda",
      businessEmail: "Email Bisnis",
      businessPhone: "Telepon Bisnis",
      businessAddress: "Alamat Bisnis",
      save: "Simpan Perubahan",
      saving: "Menyimpan...",
      saveSuccess: "Pengaturan berhasil disimpan",
      saveFailed: "Gagal menyimpan pengaturan",
      notificationSettings: "Pengaturan Notifikasi",
      emailNotifications: "Notifikasi Email",
      emailNotificationsDesc: "Terima email untuk pesan baru",
      pushNotifications: "Notifikasi Push",
      pushNotificationsDesc: "Terima notifikasi browser",
      soundNotifications: "Notifikasi Suara",
      soundNotificationsDesc: "Mainkan suara untuk pesan baru",
      shipping: "Pengiriman",
      paymentSettings: "Pembayaran",
      paymentStore: "Pembayaran Toko",
      invoice: "Invoice",
      subscription: "Langganan",
    },

    // Channels Page
    channels: {
      title: "Channel",
      subtitle: "Hubungkan channel komunikasi Anda",
      whatsapp: "WhatsApp",
      whatsappDesc: "Hubungkan WhatsApp Business untuk menerima dan mengirim pesan",
      messenger: "Facebook Messenger",
      messengerDesc: "Hubungkan Facebook Page untuk menerima chat Messenger",
      instagram: "Instagram DM",
      instagramDesc: "Hubungkan Instagram Business untuk menerima pesan langsung",
      website: "Chat Website",
      websiteDesc: "Tambahkan widget live chat ke website Anda",
      connected: "Terhubung",
      notConnected: "Tidak Terhubung",
      connect: "Hubungkan",
      disconnect: "Putuskan",
      configure: "Konfigurasi",
      reconnect: "Hubungkan Ulang",
      connectionFailed: "Koneksi gagal",
      tryAgain: "Coba Lagi",
      selectAgent: "Pilih AI Agent",
      saveAgent: "Simpan Agent",
      agentSaved: "Agent berhasil disimpan",
      agentSaveFailed: "Gagal menyimpan agent",
      disconnected: "Channel berhasil diputus",
      disconnectFailed: "Gagal memutus channel",
      
      // WhatsApp Methods
      waMethodTitle: "Pilih Metode WhatsApp",
      waMethodNerava: "Nomor Bersama Nerava",
      waMethodNeravaDe: "Gunakan nomor WhatsApp Nerava untuk menerima chat",
      waMethodQr: "Scan QR Code",
      waMethodQrDesc: "Hubungkan WhatsApp Anda dengan scan QR",
      waMethodCloud: "Cloud API",
      waMethodCloudDesc: "Untuk bisnis besar dengan Meta Business Account",
      
      // Website Chat
      getEmbedCode: "Dapatkan Kode Embed",
      embedCodeTitle: "Kode Embed Chat Widget",
      embedCodeDesc: "Salin kode ini dan paste di website Anda sebelum tag </body>",
      copyCode: "Salin Kode",
      codeCopied: "Kode disalin!",
    },

    // Common
    common: {
      loading: "Memuat...",
      error: "Terjadi kesalahan",
      retry: "Coba Lagi",
      cancel: "Batal",
      confirm: "Konfirmasi",
      save: "Simpan",
      delete: "Hapus",
      edit: "Edit",
      view: "Lihat",
      close: "Tutup",
      search: "Cari",
      filter: "Filter",
      export: "Export",
      import: "Import",
      refresh: "Refresh",
      back: "Kembali",
      next: "Selanjutnya",
      previous: "Sebelumnya",
      yes: "Ya",
      no: "Tidak",
      all: "Semua",
      none: "Tidak Ada",
      selectAll: "Pilih Semua",
      noData: "Tidak ada data",
      comingSoon: "Segera Hadir",
    },

    // Sidebar Navigation
    sidebar: {
      dashboard: "Dashboard",
      inbox: "Inbox",
      customers: "Pelanggan",
      orders: "Pesanan",
      products: "Produk",
      analytics: "Analitik",
      channels: "Channel",
      settings: "Pengaturan",
      aiAgents: "AI Agent",
      broadcast: "Broadcast",
      automation: "Otomasi",
      help: "Bantuan",
      logout: "Keluar",
    },

    // Onboarding
    onboarding: {
      // Step 1 - Business Info
      aboutBusiness: "Tentang Bisnis Anda",
      businessInfoDesc: "Informasi ini akan digunakan oleh AI untuk melayani customer",
      storeName: "Nama Toko / Bisnis",
      storeNamePlaceholder: "Contoh: Toko Bunga Mawar",
      storeNameRequired: "Nama toko wajib diisi",
      category: "Kategori",
      categoryRequired: "Kategori wajib dipilih",
      selectCategory: "Pilih kategori bisnis",
      shortDescription: "Deskripsi Singkat",
      descriptionPlaceholder: "Jelaskan bisnis Anda dalam 1-2 kalimat...",
      storeAddress: "Alamat Toko (Opsional)",
      fullAddress: "Alamat lengkap",
      city: "Kota",
      postalCode: "Kode Pos",
      continue: "Lanjut",
      back: "Kembali",
      skip: "Lewati",
      finish: "Selesai",
      
      // Categories
      categories: {
        fashion: "Fashion & Aksesoris",
        food: "Makanan & Minuman",
        health: "Kesehatan & Kecantikan",
        electronics: "Elektronik & Gadget",
        home: "Home & Living",
        sports: "Olahraga & Outdoor",
        automotive: "Otomotif",
        books: "Buku & Alat Tulis",
        toys: "Mainan & Hobi",
        services: "Jasa & Layanan",
        other: "Lainnya"
      },
      
      // Step 2 - Channels
      connectChannels: "Hubungkan Channel",
      channelsDesc: "Pilih channel komunikasi yang ingin Anda gunakan",
      whatsappShared: "WhatsApp Bersama",
      whatsappSharedDesc: "Gunakan nomor Nerava bersama",
      whatsappOwn: "WhatsApp Sendiri",
      whatsappOwnDesc: "Hubungkan WhatsApp Business Anda",
      messengerConnect: "Hubungkan Messenger",
      messengerConnectDesc: "Hubungkan Facebook Page Anda",
      instagramConnect: "Hubungkan Instagram",
      instagramConnectDesc: "Hubungkan Instagram Business Anda",
      websiteChat: "Website Chat",
      websiteChatDesc: "Tambahkan widget chat ke website Anda",
      connected: "Terhubung",
      connect: "Hubungkan",
      
      // Step 3 - Products
      addProducts: "Tambah Produk",
      productsDesc: "Tambahkan produk ke katalog agar AI bisa membantu customer",
      importExcel: "Import dari Excel",
      addManually: "Tambah Manual",
      productName: "Nama Produk",
      productPrice: "Harga",
      productStock: "Stok",
      productDescription: "Deskripsi",
      noProducts: "Belum ada produk",
      addFirstProduct: "Tambahkan produk pertama Anda",
      
      // Step 4 - Payment
      paymentSettings: "Pengaturan Pembayaran",
      paymentDesc: "Atur metode pembayaran untuk pelanggan Anda",
      bankTransfer: "Transfer Bank",
      ewallet: "E-Wallet",
      cod: "Bayar di Tempat (COD)",
      bankName: "Nama Bank",
      accountNumber: "Nomor Rekening",
      accountName: "Nama Pemilik Rekening",
      
      // Step 5 - AI Agent
      setupAI: "Atur AI Agent",
      aiDesc: "Sesuaikan kepribadian AI agent Anda",
      aiStyle: "Gaya AI",
      friendly: "Ramah & Santai",
      professional: "Profesional",
      casual: "Casual & Fun",
      friendlyExample: "Halo kak! Ada yang bisa dibantu?",
      professionalExample: "Selamat datang. Ada yang bisa kami bantu?",
      casualExample: "Hai! Mau cari apa nih?",
      customGreeting: "Sapaan Kustom",
      greetingPlaceholder: "Halo! Selamat datang di toko kami...",
      
      // Step 6 - Notifications
      notificationSettings: "Pengaturan Notifikasi",
      notificationDesc: "Pilih cara Anda ingin diberitahu",
      emailNotif: "Notifikasi Email",
      emailNotifDesc: "Terima email untuk pesan baru",
      pushNotif: "Notifikasi Push",
      pushNotifDesc: "Terima notifikasi browser",
      soundNotif: "Notifikasi Suara",
      soundNotifDesc: "Putar suara untuk pesan baru",
      
      // Step 7 - Finish
      allDone: "Selesai!",
      finishDesc: "Toko Anda sudah siap. Mulai chat dengan pelanggan!",
      goToDashboard: "Ke Dashboard",
      viewInbox: "Lihat Inbox",
      
      // Progress
      step: "Langkah",
      of: "dari",
    },

    // Products Page
    products: {
      title: "Produk",
      subtitle: "Kelola katalog produk",
      addProduct: "Tambah Produk",
      importProducts: "Import Produk",
      exportProducts: "Export Produk",
      searchProducts: "Cari produk...",
      totalProducts: "Total Produk",
      activeProducts: "Produk Aktif",
      outOfStock: "Stok Habis",
      loadError: "Gagal memuat produk",
      nameAndPriceRequired: "Nama dan harga wajib diisi",
      createFailed: "Gagal menambahkan produk",
      updateFailed: "Gagal mengupdate produk",
      deleteFailed: "Gagal menghapus produk",
      allCategories: "Semua Kategori",
      weight: "Berat (gram)",
      variants: "Varian",
      addVariant: "Tambah Varian",
      variantName: "Nama Varian",
      priceAdjustment: "Penyesuaian Harga",
      
      // Product Table
      image: "Gambar",
      name: "Nama",
      sku: "SKU",
      price: "Harga",
      stock: "Stok",
      category: "Kategori",
      status: "Status",
      actions: "Aksi",
      active: "Aktif",
      inactive: "Nonaktif",
      
      // Add/Edit Product
      addNewProduct: "Tambah Produk Baru",
      editProduct: "Edit Produk",
      productName: "Nama Produk",
      productSku: "SKU / Kode Produk",
      productPrice: "Harga",
      productStock: "Stok",
      productCategory: "Kategori",
      productDescription: "Deskripsi",
      productImage: "Gambar Produk",
      uploadImage: "Upload Gambar",
      saveProduct: "Simpan Produk",
      productSaved: "Produk berhasil disimpan",
      productCreated: "Produk berhasil ditambahkan",
      productDeleted: "Produk berhasil dihapus",
      confirmDeleteProduct: "Yakin ingin menghapus produk ini?",
      noProducts: "Tidak ada produk",
      
      // Import
      importFromExcel: "Import dari Excel",
      downloadTemplate: "Download Template",
      uploadFile: "Upload File",
      importing: "Mengimport...",
      importSuccess: "Produk berhasil diimport",
      importFailed: "Gagal mengimport produk",
    },
  },
  
  en: {
    // Navigation
    nav: {
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      login: "Login",
      register: "Sign Up Free",
      dashboard: "Dashboard",
      howItWorks: "How it Works",
    },
    
    // Hero Section
    hero: {
      badge: "Omnichannel CRM + AI Customer Assistant",
      title: "AI Customer Assistant for",
      titleHighlight: "Your Online Store",
      subtitle: "Nerava brings WhatsApp, Instagram, and Facebook Messenger chats into one inbox. The AI answers product, stock, and shipping questions from your own store data — around the clock, with no made-up answers.",
      cta: "Start Free Now",
      ctaTrial: "Try Free for 30 Days",
      ctaDemo: "See the Demo",
      forWho: "For online stores, small businesses, and CS teams who serve buyers over chat",
      viewFeatures: "View Features",
      demo: "View Demo",
      allFeatures: "Access all features",
      noCreditCard: "No credit card required",
      quickSetup: "~15 minute setup",
      channelsConnected: "channels connected",
      trustedBy: "WhatsApp, Instagram & Messenger via official Meta APIs",
      chatPlaceholder: "Type a message...",
      chatResponse: "Hello! I'm Nerava AI assistant. How can I help your business today?",
      chatQuestion: "How does Nerava work?",
      chatQuestionDetail: "Can you explain in more detail?",
    },
    
    // Features
    features: {
      title: "One Platform, All Business Needs",
      subtitle: "Complete features to manage customers from prospect to closing and repeat orders.",
      omnichannel: "Omnichannel Inbox",
      omnichannelDesc: "WhatsApp, Instagram, Facebook in one dashboard. No need to open multiple apps.",
      aiAgent: "24/7 AI Agent",
      aiAgentDesc: "Automatically answer customers according to your business SOP, even while you sleep.",
      crm: "CRM & Pipeline",
      crmDesc: "Manage leads from prospect to closing with an intuitive Kanban view.",
      broadcast: "Broadcast & Follow-up",
      broadcastDesc: "Send bulk messages and automated follow-ups to your saved contacts.",
      payment: "Invoice & QRIS",
      paymentDesc: "Generate invoices and QRIS payments directly from chat. Receive instant payments.",
      sheets: "Google Sheets Sync",
      sheetsDesc: "Sales data automatically synced to spreadsheet. Real-time reports.",
    },
    
    // How It Works
    howItWorks: {
      title: "How Nerava Works",
      subtitle: "From setup to closing in 4 simple steps",
      eyebrow: "Workflow",
      footnote: "No coding and no IT team. All four steps are done yourself from the dashboard.",
      step1Title: "Connect Channels",
      step1Desc: "Integrate WhatsApp, Instagram, Facebook to Nerava in minutes.",
      step1Meta: "± 3 minutes",
      step2Title: "Setup AI Agent",
      step2Desc: "Train AI with FAQ, product catalog, and your business SOP.",
      step2Meta: "± 10 minutes",
      step3Title: "Manage Customers",
      step3Desc: "Monitor all conversations, leads, and sales pipeline from one dashboard.",
      step3Meta: "Runs 24/7",
      step4Title: "Closing & Payment",
      step4Desc: "Receive orders, send invoices, and accept payments directly from chat.",
      step4Meta: "Right inside chat",
    },

    // Small label above section titles
    eyebrows: {
      features: "Core Features",
      demo: "Product Demo",
      trust: "Security & Support",
      faq: "FAQ",
      cta: "Get Started",
    },
    featuresNote: "Every feature below is active from day one, including during your free trial.",
    faqNote: "Still have a question? Email support@nerava.id and we reply on business days.",
    
    // Testimonials
    demoSection: {
      title: "See How Nerava Answers Customers",
      subtitle: "Three situations that happen most often in an online store's chat, handled with features that already work.",
    },
    trustSection: {
      title: "Security, Privacy, and Support",
      subtitle: "Your account, channel tokens, and customer data are protected at every layer — from how you log in to how Nerava connects to WhatsApp and Instagram.",
    },
    
    // FAQ
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to common questions about Nerava",
      q1: "What is Nerava?",
      a1: "Nerava is an all-in-one platform for online sellers combining omnichannel chat (WhatsApp, Instagram, Facebook Messenger, and website live chat), automated AI agent, CRM, broadcast, and payment integration in one dashboard. Everything you need to manage buyers from prospect to closing.",
      q2: "How long does setup take?",
      a2: "About 15 minutes: ~3 minutes to connect your channels and ~10 minutes to fill in your product catalog and FAQ. After that the AI can start answering customers.",
      q3: "Are there any hidden fees?",
      a3: "There are no hidden fees from Nerava — every feature in your plan is included in the subscription price. One thing to know: if you use your own WhatsApp Business number, Meta bills service-message fees directly to your WhatsApp account once you pass 1,000 free messages per month. That bill comes from Meta, not from us. Instagram, Messenger, and website chats have no per-message fee.",
      q4: "Can I upgrade or downgrade my plan?",
      a4: "Yes, you can upgrade or downgrade your plan anytime. Changes will take effect in the next billing period.",
      q5: "Which channels are supported?",
      a5: "Nerava supports WhatsApp Business API, Instagram DM, Facebook Messenger, and website live chat. All in one integrated inbox.",
      q6: "Is my data safe?",
      a6: "Passwords are stored as bcrypt hashes, WhatsApp/Instagram channel tokens are encrypted in the database, and all traffic goes over HTTPS. Each account’s data is isolated — only you and the teammates you invite can see it. Export or deletion requests are handled through support email.",
    },
    
    // Showcase Sections
    showcase: {
      inbox: {
        title: "All Chats, One Dashboard",
        subtitle: "No need to open WhatsApp, Instagram, and Facebook separately. All messages come into one integrated inbox.",
        feature1: "WhatsApp Business API integrated",
        feature2: "Instagram DM auto-reply",
        feature3: "Facebook Messenger support",
        feature4: "Live chat for website",
        feature5: "Chat history saved automatically",
        all: "All",
        newMessage: "New message...",
      },
      crm: {
        title: "Manage Leads More Structured",
        subtitle: "Kanban view to see all leads at every sales stage. No more leads slipping through the cracks.",
        feature1: "Visual drag & drop pipeline",
        feature2: "Custom stages for your business",
        feature3: "Auto-tagging based on behavior",
        feature4: "Automatic follow-up reminders",
      },
      ai: {
        title: "AI Agent That Understands Your Business",
        subtitle: "Train AI with your product catalog, FAQ, and business SOP. AI will answer customers 24/7 in your brand voice.",
        feature1: "Training with your business data",
        feature2: "Understands conversation context",
        feature3: "Handover to human when needed",
        feature4: "Multi-language (ID & EN)",
      },
      broadcast: {
        title: "Reach Your Whole Contact List",
        subtitle: "Send promo messages, follow-ups, or reminders to your saved contacts in one click. Personalize messages for higher engagement.",
        feature1: "Broadcast to all channels",
        feature2: "Ready-to-use message templates",
        feature3: "Personalize with customer names",
        feature4: "Schedule sending",
        feature5: "Track open rate & response",
        createNew: "Create New Broadcast",
        recipients: "Recipients Segment",
        allCustomers: "All Customers",
        message: "Message",
        sendBroadcast: "Send Broadcast",
      },
      payment: {
        title: "Receive Payments Directly from Chat",
        subtitle: "Generate invoices and QRIS directly from chat. Customers can pay instantly without leaving WhatsApp.",
        feature1: "Generate invoices in 1 click",
        feature2: "Automatic dynamic QRIS",
        feature3: "Real-time payment notifications",
        feature4: "Daily transaction recap",
        scanQris: "Scan QRIS to pay",
        copyLink: "Copy Link",
        sendToCustomer: "Send to Customer",
      },
    },
    
    // Pricing
    pricing: {
      title: "Affordable Pricing for SMEs",
      subtitle: "Choose a plan that fits your business needs",
      free: "Free",
      pro: "Pro",
      enterprise: "Enterprise",
      perMonth: "/month",
      startFree: "Start Free",
      choosePro: "Choose Pro",
      contactSales: "Contact Sales",
      freePlan: {
        description: "Perfect to get started",
        aiAgent: "1 AI Agent",
        chats: "100 chats/month",
        analytics: "Basic analytics",
        support: "Email support",
      },
      proPlan: {
        description: "For growing businesses",
        aiAgents: "5 AI Agents",
        chats: "5,000 chats/month",
        analytics: "Complete CRM & Pipeline",
        support: "Priority support",
        customization: "Unlimited broadcast",
      },
      enterprisePlan: {
        description: "For large enterprises",
        unlimited: "Unlimited AI Agents",
        unlimitedChats: "Unlimited chats",
        advancedAnalytics: "Advanced analytics",
        dedicatedSupport: "Dedicated support",
        customIntegration: "Custom integration",
        sla: "SLA guarantee",
      },
      cta: {
        title: "Ready to Boost Your Business Efficiency?",
        subtitle: "Start a free 30-day trial, connect your channels, and let the AI answer customer questions from your own store data.",
        button: "Try Free for 30 Days",
        note: "No credit card • Access all features • Cancel anytime",
      },
    },
    
    // Footer
    footer: {
      description: "All-in-one platform for Indonesian online sellers. Omnichannel chat, AI agent, CRM, and payment in one dashboard.",
      product: "Product",
      channels: "Channels",
      pricing: "Pricing",
      company: "Company",
      about: "About Us",
      careers: "Careers",
      blog: "Blog",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "Copyright",
      allRightsReserved: "All rights reserved",
    },
    
    // Integration
    integration: {
      title: "Connect All Your Channels",
      subtitle: "Nerava integrates with communication platforms your business uses",
      wordpress: "Install with plugin or embed code",
      shopify: "Integrate through theme editor",
      wix: "Add via HTML embed",
      custom: "Copy-paste JavaScript code",
      laravel: "Integrate via Blade template",
      react: "Import as script tag",
    },
    
    // Documentation
    documentation: {
      title: "Documentation",
      subtitle: "Complete guide to get started with Nerava",
      quickStart: "Quick Start",
      quickStartDesc: "Get started in 5 minutes with installation guide",
      apiDocs: "API Documentation",
      apiDocsDesc: "Complete API reference for advanced integration",
      customization: "Customization Guide",
      customizationDesc: "Learn how to customize your AI Agent",
    },
    
    
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "Have questions? Our team is ready to help",
      email: "Email",
      whatsapp: "WhatsApp",
      response: "We'll respond within 24 hours",
    },
    
    // Modal
    modal: {
      title: "Manage Customers More Efficiently!",
      subtitle: "Bring",
      thousands: "WhatsApp, Instagram & Messenger",
      using: "into one AI-powered inbox",
      benefit1: "Free for 30 days, no credit card required",
      benefit2: "Setup in about 15 minutes",
      benefit3: "Indonesian Language Support",
      registerNow: "Sign Up Now - Free!",
      haveAccount: "Already Have an Account? Login",
      close: "Close",
    },
    
    // Dashboard
    dashboard: {
      title: "Dashboard",
      welcome: "Welcome back",
      yourPlan: "Your Plan",
      upgrade: "Upgrade",
      usage: "Usage",
      aiAgents: "AI Agents",
      chats: "Chats this month",
      totalChats: "Total Chats",
      activeBots: "Active Agents",
      avgResponse: "Avg Response",
      createBot: "Create New AI Agent",
      myBots: "My AI Agents",
      noBots: "No AI Agents yet",
      createFirst: "Create your first AI Agent",
      viewDetails: "View Details",
      analytics: "Analytics",
      // Create Modal
      createModalTitle: "Create New AI Agent",
      createModalSubtitle: "Quick Setup!",
      createModalDesc: "Create your AI agent in 2 easy steps. After creation, you can customize it further.",
      botName: "AI Agent Name",
      botNamePlaceholder: "Example: Customer Support Agent",
      botNameDesc: "Give it a memorable name",
      description: "Description (Optional)",
      descPlaceholder: "Example: AI Agent to answer customer questions about products and services",
      descDesc: "Describe your AI Agent's purpose",
      tips: "Tips",
      tipsText: "After creation, you can configure prompts, FAQs, colors, and connect to channels like WhatsApp.",
      cancel: "Cancel",
      create: "Create AI Agent",
      creating: "Creating...",
      // Extended dashboard keys  
      overview: "Overview",
      todayStats: "Today's Statistics",
      totalRevenue: "Total Revenue",
      totalOrders: "Total Orders",
      newCustomers: "New Customers",
      pendingOrders: "Pending Orders",
      recentOrders: "Recent Orders",
      recentConversations: "Recent Conversations",
      viewAll: "View All",
      noOrders: "No orders yet",
      noConversations: "No conversations yet",
      quickActions: "Quick Actions",
      newOrder: "New Order",
      addProduct: "Add Product",
      sendBroadcast: "Send Broadcast",
      // Order Status
      orderStatus: {
        pending: "Pending",
        paid: "Paid",
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
      },
      // Trial
      trialExpires: "Trial expires in",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      seconds: "seconds",
      trialExpired: "Trial Expired",
      upgradeToPro: "Upgrade to Pro",
      // Insights
      conversionFunnel: "Conversion Funnel",
      channelPerformance: "Channel Performance",
      customerInsights: "Customer Insights",
      responseTime: "Response Time",
      avgResponseTime: "Average Response Time",
    },
    
    // Profile
    profile: {
      title: "Profile Settings",
      info: "Profile Information",
      name: "Full Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailNote: "Email cannot be changed",
      updateInfo: "Update Information",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "New password (min. 6 characters)",
      confirmPassword: "Confirm New Password",
      confirmPasswordPlaceholder: "Repeat new password",
      updatePassword: "Change Password",
      saveProfile: "Save Profile",
      saving: "Saving...",
      success: "Profile updated successfully",
      passwordSuccess: "Password updated successfully",
      nameEmpty: "Name cannot be empty",
      passwordFieldsRequired: "All password fields are required",
      passwordMinLength: "New password must be at least 6 characters",
      passwordMismatch: "New passwords do not match",
      updateFailed: "Failed to update profile",
      passwordUpdateFailed: "Failed to update password",
      // Notifications
      notificationsSaved: "Notification settings saved",
      notificationsSaveFailed: "Failed to save settings",
      enterTelegramId: "Enter Telegram Chat ID",
      telegramVerified: "Telegram verified successfully! Check your Telegram messages.",
      telegramVerifyFailed: "Failed to verify Telegram",
      testNotifFailed: "Failed to send test notification",
      // Extended profile keys
      personalInfo: "Personal Information",
      fullName: "Full Name",
      phone: "Phone Number",
      updateProfile: "Update Profile",
      profileUpdated: "Profile updated successfully",
      passwordChanged: "Password changed successfully",
      incorrectPassword: "Current password is incorrect",
      // Business Profile
      businessProfile: "Business Profile",
      storeName: "Store Name",
      businessCategory: "Business Category",
      businessDescription: "Business Description",
      storeAddress: "Store Address",
      city: "City",
      saveBusinessProfile: "Save Business Profile",
      savingBusiness: "Saving...",
      selectCategory: "Select category",
      storeNamePlaceholder: "Example: Mawar Flower Shop",
      descriptionPlaceholder: "Tell us about your business...",
      addressPlaceholder: "123 Example Street",
      cityPlaceholder: "Jakarta",
    },
    
    // Payment
    payment: {
      title: "Payment",
      subtitle: "Choose payment method to upgrade to",
      method: "Payment Method",
      bankTransfer: "Bank Transfer (Virtual Account)",
      bankTransferDesc: "BCA, BNI, Mandiri, BRI, Permata, CIMB",
      eWallet: "E-Wallet / Digital Wallet",
      eWalletDesc: "OVO, DANA, GoPay, ShopeePay, LinkAja",
      qris: "QRIS",
      qrisDesc: "Scan QR from all e-wallets & mobile banking",
      creditCard: "Credit / Debit Card",
      creditCardDesc: "Visa, Mastercard, JCB",
      selectBank: "Select Bank",
      selectWallet: "Select E-Wallet",
      orderSummary: "Order Summary",
      package: "Package",
      period: "Period",
      month: "month",
      total: "Total",
      payNow: "Pay Now",
      processing: "Processing...",
      securePayment: "Secure & encrypted payment",
      selectMethod: "Select payment method",
      selectBankError: "Please select a bank",
      selectWalletError: "Please select an e-wallet",
      processingPayment: "Processing payment...",
      paymentSuccess: "Payment successful! Thank you for subscribing.",
    },

    // Settings Page
    settings: {
      title: "Settings",
      general: "General",
      notifications: "Notifications",
      billing: "Billing",
      team: "Team",
      businessInfo: "Business Information",
      businessName: "Business Name",
      businessNamePlaceholder: "Enter your business name",
      businessEmail: "Business Email",
      businessPhone: "Business Phone",
      businessAddress: "Business Address",
      save: "Save Changes",
      saving: "Saving...",
      saveSuccess: "Settings saved successfully",
      saveFailed: "Failed to save settings",
      notificationSettings: "Notification Settings",
      emailNotifications: "Email Notifications",
      emailNotificationsDesc: "Receive email for new messages",
      pushNotifications: "Push Notifications",
      pushNotificationsDesc: "Receive browser notifications",
      soundNotifications: "Sound Notifications",
      soundNotificationsDesc: "Play sound for new messages",
      shipping: "Shipping",
      paymentSettings: "Payment",
      paymentStore: "Store Payment",
      invoice: "Invoice",
      subscription: "Subscription",
    },
    
    // Plan Limit Messages
    limits: {
      aiAgentLimit: "AI Agent limit reached",
      aiAgentLimitDesc: "{plan} plan can only create {max} AI Agent(s). Upgrade to Pro plan to create more.",
      chatLimit: "Monthly chat limit reached",
      chatLimitDesc: "You've reached the limit of {max} chats per month. Upgrade to Pro plan for more chats.",
      upgradeNow: "Upgrade Now",
    },
    
    // AI Agent Detail
    aiAgentDetail: {
      editAiAgent: "Edit AI Agent",
      viewAnalytics: "View Analytics",
      save: "Save",
      saving: "Saving...",
      tabGeneral: "General",
      tabPrompt: "Prompt",
      tabFaq: "FAQ",
      tabEmbed: "Embed",
      basicInfo: "Basic Information",
      aiAgentName: "AI Agent Name",
      description: "Description",
      widgetAppearance: "Widget Appearance",
      primaryColor: "Primary Color",
      welcomeMessage: "Welcome Message",
      language: "Language",
      languageId: "Indonesian",
      languageEn: "English",
      languageBoth: "Both (Auto-detect)",
      systemPrompt: "System Prompt",
      systemPromptDesc: "Basic instructions for AI on how the agent should behave.",
      promptSizeLabel: "Prompt length",
      promptSizeChars: "characters",
      promptSizeTokens: "tokens/reply",
      promptSizeHint: "This prompt is re-sent to the AI on every customer message.",
      promptSizeIdeal: "Ideal — fastest responses and lowest AI cost.",
      promptSizeWarn: "A bit long. Trim below 1,500 characters for faster, cheaper replies.",
      promptSizeHigh: "Too long. Move product details to Product Catalog and common questions to the FAQ tab instead of stacking them here.",
      systemPromptPlaceholder: "Example: You are a customer service assistant for XYZ Store. Answer questions in a friendly and professional manner. If you don't know, direct to CS contact.",
      faqTitle: "FAQ",
      faqDesc: "Add common questions for more accurate responses",
      addFaq: "Add FAQ",
      noFaq: "No FAQs yet. Click the button above to add.",
      faqNumber: "FAQ #",
      question: "Question",
      questionPlaceholder: "Example: What is the price of product A?",
      answer: "Answer",
      answerPlaceholder: "Answer to the question above",
      embedCode: "Embed Code",
      embedDesc: "Copy the code below and paste before the </body> tag on your website.",
      generateEmbed: "Generate Embed Code",
      generating: "Generating...",
      regenerate: "Regenerate",
      previewChat: "Chat Preview",
      previewDesc: "Test your AI Agent here",
      typePlaceholder: "Type a message...",
      loadFailed: "Failed to load AI Agent data",
      saveSuccess: "AI Agent saved successfully!",
      saveFailed: "Failed to save AI Agent",
      embedSuccess: "Embed code generated successfully!",
      embedFailed: "Failed to generate embed code",
      codeCopied: "Code copied!",
      errorMessage: "Sorry, an error occurred.",
    },

    // Analytics
    analytics: {
      title: "Analytics",
      overallPerformance: "Overall Performance",
      aiAgentAnalytics: "AI Agent Analytics",
      viewFullAnalytics: "View Full Analytics",
      conversations: "Conversations",
      avgResponseTime: "Avg Response Time",
      satisfactionRate: "Satisfaction Rate",
      activeUsers: "Active Users",
      topQuestions: "Top Questions",
      sentimentAnalysis: "Sentiment Analysis",
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
      recentChats: "Recent Chats",
      noData: "No data yet",
      loading: "Loading...",
    },
    
    // Auth & Errors
    auth: {
      loginSuccess: "Login successful!",
      continueWithGoogle: "Continue with Google",
      orDivider: "or",
      googleLoginFailed: "Google login failed, please try again",
      connectingGoogle: "Connecting your Google account...",
      loginFailed: "Login failed",
      registerSuccess: "Registration successful!",
      registerFailed: "Registration failed",
      welcomeBack: "Welcome Back!",
      welcomeBackDesc: "Login to manage your business and monitor all customer conversations.",
      loginToAccount: "Login to Account",
      loginSubtitle: "Please enter your email and password",
      startJourney: "Start Your Journey",
      joinBusiness: "Bring WhatsApp, Instagram, and Messenger chats into one AI-powered inbox",
      createAccount: "Create your account and start for free",
      benefit1: "Free for 30 days, no credit card",
      benefit2: "Setup in about 15 minutes",
      benefit3: "Indonesian language support",
      testimonialText: "The AI answers product, stock, and shipping questions from your own store data. WhatsApp, Instagram, and Messenger chats land in one inbox, together with their orders and payments.",
      testimonialName: "What you get from day one",
      testimonialRole: "Every feature is active during the trial",
      loginTitle: "Login",
      registerTitle: "Register",
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: "Already have an account?",
      signUpFree: "Sign up free",
      email: "Email",
      password: "Password",
      name: "Name",
      enterPassword: "Enter password",
      enterEmail: "name@email.com",
      enterName: "Enter your full name",
      login: "Login",
      register: "Register",
      creating: "Creating account...",
      passwordShort: "Password must be at least 6 characters",
    },
    
    // Error Messages
    errors: {
      aiAgentLimitReached: "AI Agent limit reached. FREE plan can only create 1 AI Agent. Upgrade to Pro plan to create more.",
      chatLimitReached: "Monthly chat limit reached. Upgrade to Pro plan for more chats.",
    },

    // Inbox Page
    inbox: {
      title: "Inbox",
      subtitle: "Manage all customer conversations in one place",
      allChannels: "All Channels",
      whatsapp: "WhatsApp",
      messenger: "Messenger", 
      instagram: "Instagram",
      website: "Website",
      search: "Search conversations...",
      noConversations: "No conversations yet",
      noConversationsDesc: "Conversations will appear here when customers start chatting",
      unread: "unread",
      bot: "Bot",
      human: "Human",
      resolved: "Resolved",
      active: "Active",
      filterAll: "All",
      filterUnread: "Unread",
      filterBot: "Bot Active",
      filterHuman: "Human Active",
      needsAttention: "Needs Attention",
      notificationsActive: "Notifications active",
      enableNotifications: "Enable notifications",
      viewAnalytics: "View Analytics",
      waitingMessages: "Waiting for messages",
      channelConnectedDesc: "Channel connected. Customer messages will appear here automatically.",
      connectChannel: "Connect Channel",
      // Bulk Actions
      selected: "selected",
      selectAll: "Select all",
      deselectAll: "Deselect all",
      markRead: "Mark Read",
      markUnread: "Mark Unread",
      archive: "Archive",
      unarchive: "Unarchive",
      delete: "Delete",
      bulkMarkReadSuccess: "Conversations marked as read",
      bulkMarkUnreadSuccess: "Conversations marked as unread",
      bulkArchiveSuccess: "Conversations archived",
      bulkUnarchiveSuccess: "Conversations restored from archive",
      bulkDeleteSuccess: "Conversations deleted",
      bulkActionError: "Failed to perform bulk action",
    },

    // Conversation Detail
    conversation: {
      backToInbox: "Back to Inbox",
      customer: "Customer",
      channel: "Channel",
      status: "Status",
      handledBy: "Handled by",
      takeOver: "Take Over (Manual)",
      handToBot: "Return to Bot",
      markResolved: "Mark Resolved",
      reopen: "Reopen",
      typeMessage: "Type your reply...",
      send: "Send",
      sending: "Sending...",
      you: "You",
      botActive: "Bot active - click menu to Take Over",
      manualMode: "Manual mode - Bot paused",
      noMessages: "No messages in this conversation yet",
      notFound: "Conversation not found",
      viewCustomerProfile: "View Customer Profile",
    },

    // Customers Page
    customers: {
      title: "Customers",
      subtitle: "Manage your customer database",
      search: "Search customers...",
      addCustomer: "Add Customer",
      exportExcel: "Export Excel",
      name: "Name",
      phone: "Phone",
      email: "Email",
      channel: "Channel",
      totalOrders: "Total Orders",
      totalSpent: "Total Spent",
      lastContact: "Last Contact",
      actions: "Actions",
      noCustomers: "No customers yet",
      noCustomersDesc: "Customers will appear here when they start chatting",
      viewDetails: "View Details",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: "Are you sure you want to delete this customer?",
      totalCustomers: "Total Customers",
      new: "New",
      thisMonth: "This month",
      repeat: "Repeat",
      avgSpent: "Avg. Spent",
      perCustomer: "Per customer",
      orderHistory: "Order History",
      saveNotes: "Save Notes",
      addNotesPlaceholder: "Add notes about this customer...",
      // Extended customers keys
      searchCustomers: "Search name, phone, address...",
      activeCustomers: "Active Customers",
      newThisMonth: "New This Month",
      lastOrder: "Last Order",
      joined: "Joined",
      // Customer Detail
      customerDetail: "Customer Detail",
      conversationHistory: "Conversation History",
      customerNotes: "Customer Notes",
      addNote: "Add Note",
      notesSaved: "Notes saved",
      notesSaveFailed: "Failed to save notes",
      // Add/Edit Customer
      addNewCustomer: "Add New Customer",
      editCustomer: "Edit Customer",
      customerName: "Customer Name",
      customerPhone: "Phone Number",
      customerEmail: "Email Address",
      customerAddress: "Address",
      saveCustomer: "Save Customer",
      customerSaved: "Customer saved successfully",
      customerCreated: "Customer created successfully",
      customerDeleted: "Customer deleted successfully",
      confirmDeleteCustomer: "Are you sure you want to delete this customer?",
      loadError: "Failed to load customer details",
    },

    // Orders Page  
    orders: {
      title: "Orders",
      subtitle: "Manage all your orders",
      search: "Search orders...",
      addOrder: "Add Order",
      exportExcel: "Export Excel",
      orderId: "Order ID",
      customer: "Customer",
      products: "Products",
      total: "Total",
      status: "Status",
      paymentStatus: "Payment",
      date: "Date",
      actions: "Actions",
      noOrders: "No orders yet",
      noOrdersDesc: "Orders will appear here when customers make purchases",
      viewDetails: "View Details",
      updateStatus: "Update Status",
      pending: "Pending",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled",
      paid: "Paid",
      unpaid: "Unpaid",
      refunded: "Refunded",
      // Extended orders keys
      newOrder: "New Order",
      searchOrders: "Search orders...",
      filterByStatus: "Filter by status",
      allStatus: "All Status",
      orderNumber: "Order Number",
      viewOrder: "View Order",
      editOrder: "Edit Order",
      deleteOrder: "Delete Order",
      confirmDelete: "Are you sure you want to delete this order?",
      orderDeleted: "Order deleted successfully",
      totalOrders: "Total Orders",
      receivables: "Receivables",
      revenue: "Revenue",
      loadError: "Failed to load orders",
      statusUpdated: "Status updated successfully",
      statusUpdateFailed: "Failed to update status",
      trackingSaved: "Shipping info saved successfully",
      trackingSaveFailed: "Failed to save shipping info",
      // Order Detail
      orderDetail: "Order Detail",
      orderInfo: "Order Information",
      customerInfo: "Customer Information",
      items: "Items",
      subtotal: "Subtotal",
      shipping: "Shipping",
      discount: "Discount",
      grandTotal: "Grand Total",
      paymentMethod: "Payment Method",
      shippingAddress: "Shipping Address",
      notes: "Notes",
      timeline: "Timeline",
      // Create/Edit Order
      createOrder: "Create Order",
      editOrderTitle: "Edit Order",
      selectCustomer: "Select Customer",
      addItem: "Add Item",
      selectProduct: "Select Product",
      quantity: "Quantity",
      price: "Price",
      removeItem: "Remove Item",
      saveOrder: "Save Order",
      orderSaved: "Order saved successfully",
      orderCreated: "Order created successfully",
    },

    // Channels Page
    channels: {
      title: "Channels",
      subtitle: "Connect your communication channels",
      whatsapp: "WhatsApp",
      whatsappDesc: "Connect WhatsApp Business to receive and send messages",
      messenger: "Facebook Messenger",
      messengerDesc: "Connect your Facebook Page to receive Messenger chats",
      instagram: "Instagram DM",
      instagramDesc: "Connect Instagram Business to receive direct messages",
      website: "Website Chat",
      websiteDesc: "Add live chat widget to your website",
      connected: "Connected",
      notConnected: "Not Connected",
      connect: "Connect",
      disconnect: "Disconnect",
      configure: "Configure",
      reconnect: "Reconnect",
      connectionFailed: "Connection failed",
      tryAgain: "Try Again",
      selectAgent: "Select AI Agent",
      saveAgent: "Save Agent",
      agentSaved: "Agent saved successfully",
      agentSaveFailed: "Failed to save agent",
      disconnected: "Channel disconnected successfully",
      disconnectFailed: "Failed to disconnect channel",
      
      // WhatsApp Methods
      waMethodTitle: "Choose WhatsApp Method",
      waMethodNerava: "Nerava Shared Number",
      waMethodNeravaDe: "Use Nerava's WhatsApp number to receive chats",
      waMethodQr: "Scan QR Code",
      waMethodQrDesc: "Connect your WhatsApp by scanning QR",
      waMethodCloud: "Cloud API",
      waMethodCloudDesc: "For large businesses with Meta Business Account",
      
      // Website Chat
      getEmbedCode: "Get Embed Code",
      embedCodeTitle: "Chat Widget Embed Code",
      embedCodeDesc: "Copy this code and paste it on your website before the </body> tag",
      copyCode: "Copy Code",
      codeCopied: "Code copied!",
    },

    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      retry: "Retry",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      close: "Close",
      search: "Search",
      filter: "Filter",
      export: "Export",
      import: "Import",
      refresh: "Refresh",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
      all: "All",
      none: "None",
      selectAll: "Select All",
      noData: "No data",
      comingSoon: "Coming Soon",
    },

    // Sidebar Navigation
    sidebar: {
      dashboard: "Dashboard",
      inbox: "Inbox",
      customers: "Customers",
      orders: "Orders",
      products: "Products",
      analytics: "Analytics",
      channels: "Channels",
      settings: "Settings",
      aiAgents: "AI Agents",
      broadcast: "Broadcast",
      automation: "Automation",
      help: "Help & Support",
      logout: "Logout",
    },

    // Onboarding
    onboarding: {
      // Step 1 - Business Info
      aboutBusiness: "About Your Business",
      businessInfoDesc: "This information will be used by AI to serve customers",
      storeName: "Store / Business Name",
      storeNamePlaceholder: "Example: Mawar Flower Shop",
      storeNameRequired: "Store name is required",
      category: "Category",
      categoryRequired: "Category is required",
      selectCategory: "Select business category",
      shortDescription: "Short Description",
      descriptionPlaceholder: "Describe your business in 1-2 sentences...",
      storeAddress: "Store Address (Optional)",
      fullAddress: "Full address",
      city: "City",
      postalCode: "Postal Code",
      continue: "Continue",
      back: "Back",
      skip: "Skip",
      finish: "Finish",
      
      // Categories
      categories: {
        fashion: "Fashion & Accessories",
        food: "Food & Beverages",
        health: "Health & Beauty",
        electronics: "Electronics & Gadgets",
        home: "Home & Living",
        sports: "Sports & Outdoor",
        automotive: "Automotive",
        books: "Books & Stationery",
        toys: "Toys & Hobbies",
        services: "Services",
        other: "Other"
      },
      
      // Step 2 - Channels
      connectChannels: "Connect Channels",
      channelsDesc: "Choose communication channels you want to use",
      whatsappShared: "Shared WhatsApp",
      whatsappSharedDesc: "Use Nerava's shared number",
      whatsappOwn: "Own WhatsApp",
      whatsappOwnDesc: "Connect your WhatsApp Business",
      messengerConnect: "Connect Messenger",
      messengerConnectDesc: "Connect your Facebook Page",
      instagramConnect: "Connect Instagram",
      instagramConnectDesc: "Connect your Instagram Business",
      websiteChat: "Website Chat",
      websiteChatDesc: "Add chat widget to your website",
      connected: "Connected",
      connect: "Connect",
      
      // Step 3 - Products
      addProducts: "Add Products",
      productsDesc: "Add products to your catalog so AI can help customers",
      importExcel: "Import from Excel",
      addManually: "Add Manually",
      productName: "Product Name",
      productPrice: "Price",
      productStock: "Stock",
      productDescription: "Description",
      noProducts: "No products yet",
      addFirstProduct: "Add your first product",
      
      // Step 4 - Payment
      paymentSettings: "Payment Settings",
      paymentDesc: "Set up payment methods for your customers",
      bankTransfer: "Bank Transfer",
      ewallet: "E-Wallet",
      cod: "Cash on Delivery (COD)",
      bankName: "Bank Name",
      accountNumber: "Account Number",
      accountName: "Account Name",
      
      // Step 5 - AI Agent
      setupAI: "Set Up AI Agent",
      aiDesc: "Customize your AI agent personality",
      aiStyle: "AI Style",
      friendly: "Friendly & Casual",
      professional: "Professional",
      casual: "Casual & Fun",
      friendlyExample: "Hi! How can I help?",
      professionalExample: "Welcome. How may we assist you?",
      casualExample: "Hey! What are you looking for?",
      customGreeting: "Custom Greeting",
      greetingPlaceholder: "Hello! Welcome to our store...",
      
      // Step 6 - Notifications
      notificationSettings: "Notification Settings",
      notificationDesc: "Choose how you want to be notified",
      emailNotif: "Email Notifications",
      emailNotifDesc: "Receive email for new messages",
      pushNotif: "Push Notifications",
      pushNotifDesc: "Receive browser notifications",
      soundNotif: "Sound Notifications",
      soundNotifDesc: "Play sound for new messages",
      
      // Step 7 - Finish
      allDone: "All Done!",
      finishDesc: "Your store is ready. Start chatting with customers!",
      goToDashboard: "Go to Dashboard",
      viewInbox: "View Inbox",
      
      // Progress
      step: "Step",
      of: "of",
    },

    // Products Page
    products: {
      title: "Products",
      subtitle: "Manage your product catalog",
      addProduct: "Add Product",
      importProducts: "Import Products",
      exportProducts: "Export Products",
      searchProducts: "Search products...",
      totalProducts: "Total Products",
      activeProducts: "Active Products",
      outOfStock: "Out of Stock",
      loadError: "Failed to load products",
      nameAndPriceRequired: "Name and price are required",
      createFailed: "Failed to add product",
      updateFailed: "Failed to update product",
      deleteFailed: "Failed to delete product",
      allCategories: "All Categories",
      weight: "Weight (gram)",
      variants: "Variants",
      addVariant: "Add Variant",
      variantName: "Variant Name",
      priceAdjustment: "Price Adjustment",
      
      // Product Table
      image: "Image",
      name: "Name",
      sku: "SKU",
      price: "Price",
      stock: "Stock",
      category: "Category",
      status: "Status",
      actions: "Actions",
      active: "Active",
      inactive: "Inactive",
      
      // Add/Edit Product
      addNewProduct: "Add New Product",
      editProduct: "Edit Product",
      productName: "Product Name",
      productSku: "SKU / Product Code",
      productPrice: "Price",
      productStock: "Stock",
      productCategory: "Category",
      productDescription: "Description",
      productImage: "Product Image",
      uploadImage: "Upload Image",
      saveProduct: "Save Product",
      productSaved: "Product saved successfully",
      productCreated: "Product created successfully",
      productDeleted: "Product deleted successfully",
      confirmDeleteProduct: "Are you sure you want to delete this product?",
      noProducts: "No products found",
      
      // Import
      importFromExcel: "Import from Excel",
      downloadTemplate: "Download Template",
      uploadFile: "Upload File",
      importing: "Importing...",
      importSuccess: "Products imported successfully",
      importFailed: "Failed to import products",
    },
  },
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value || key;
};
